var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWorld = function SvgWorld(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M12 23.143c6.154 0 11.143-4.989 11.143-11.143S18.154.857 12 .857.857 5.847.857 12 5.846 23.143 12 23.143"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M1.714 16.286h3a3 3 0 0 0 3-3v-2.571a3 3 0 0 1 3-3 3 3 0 0 0 3-3V.978m9.429 10.851a6.1 6.1 0 0 0-2.777-.686h-3.652a3 3 0 1 0 0 6 2.143 2.143 0 0 1 2.143 2.143v1.491"
  })));
};
export default SvgWorld;